var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "pro-layout",
    _vm._b(
      {
        attrs: {
          menus: _vm.menus,
          collapsed: _vm.collapsed,
          mediaQuery: _vm.query,
          isMobile: _vm.isMobile,
          handleMediaQuery: _vm.handleMediaQuery,
          handleCollapse: _vm.handleCollapse,
          i18nRender: false,
          breadcrumbRender: _vm.handleBreadcrumbRender,
          siderWidth: 210,
        },
        scopedSlots: _vm._u([
          {
            key: "menuHeaderRender",
            fn: function () {
              return [
                _c("div", [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/logo-j.svg"),
                      alt: "jeequan",
                    },
                  }),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.collapsed,
                        expression: "!collapsed",
                      },
                    ],
                    staticStyle: { width: "90px", margin: "5px 0 0 5px" },
                    attrs: {
                      src: require("@/assets/svg/jeepay.svg"),
                      alt: "jeepay",
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "headerContentRender",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass: "ant-pro-global-header-trigger",
                    on: {
                      click: function ($event) {
                        return _vm.routeReload()
                      },
                    },
                  },
                  [
                    _c(
                      "a-tooltip",
                      { attrs: { title: "刷新页面" } },
                      [
                        _c("a-icon", {
                          staticStyle: {
                            "font-size": "18px",
                            cursor: "pointer",
                          },
                          attrs: { type: "reload" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "rightContentRender",
            fn: function () {
              return [
                _c("right-content", {
                  attrs: {
                    "top-menu": _vm.settings.layout === "topmenu",
                    "is-mobile": _vm.isMobile,
                    theme: _vm.settings.theme,
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "footerRender",
            fn: function () {
              return [_c("global-footer")]
            },
            proxy: true,
          },
        ]),
      },
      "pro-layout",
      _vm.settings,
      false
    ),
    [_vm.isRouterAlive ? _c("router-view") : _vm._e()],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }